/**
 * 개인정보처리방침 전문. `.doc-body` 안에서 h3/h4/p/ul 태그 셀렉터로 스타일이 잡힌다 —
 * 태그를 바꾸면 서식이 깨진다.
 */
export function PrivacyDocument() {
  return (
    <div className="doc-body">
      <p>
        (주)플레인비트(이하 ‘회사’)은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및
        권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과
        같은 처리방침을 두고 있습니다.
      </p>
      <p>
        ‘회사’ 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여
        공지할 것입니다.
      </p>
      <p>○ 본 방침은부터 2021년 1월 1일부터 시행됩니다.</p>

      <h3>1. 개인정보의 처리 목적</h3>
      <p>
        ‘회사’는 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의
        목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할
        예정입니다.
      </p>
      <h4>가. 홈페이지 회원가입 및 관리</h4>
      <p>
        회원제 서비스 제공에 따른 본인 식별·인증, 제한적 본인확인제 시행에 따른 본인확인,
        서비스 부정이용 방지 등을 목적으로 개인정보를 처리합니다.
      </p>
      <h4>나. 민원사무 처리</h4>
      <p>
        민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을
        목적으로 개인정보를 처리합니다.
      </p>
      <h4>다. 재화 또는 서비스 제공</h4>
      <p>서비스 제공 등을 목적으로 개인정보를 처리합니다.</p>
      <h4>라. 마케팅 및 광고에의 활용</h4>
      <p>
        서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을
        목적으로 개인정보를 처리합니다.
      </p>

      <h3>2. 개인정보 파일 현황</h3>
      <h4>2-1. 개인정보 파일명 : 개인정보</h4>
      <ul role="list">
        <li>
          개인정보 항목 : 이메일, 휴대전화번호, 회사전화번호, 직책, 부서, 회사명, 접속 로그,
          접속 IP 정보, 법정대리인 이름
        </li>
        <li>수집방법 : 홈페이지</li>
        <li>보유근거 : 개인정보동의</li>
        <li>보유기간 : 3년</li>
        <li>
          관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년, 소비자의 불만 또는
          분쟁처리에 관한 기록 : 3년, 계약 또는 청약철회 등에 관한 기록 : 5년
        </li>
      </ul>

      <h3>3. 개인정보의 처리 및 보유 기간</h3>
      <p>
        ① ‘회사’는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를
        수집시에 동의 받은 개인정보 보유,이용기간 내에서 개인정보를 처리,보유합니다.
      </p>
      <p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
      <h4>3-1. &lt;민원사무 처리&gt;</h4>
      <p>
        &lt;민원사무 처리&gt;와 관련한 개인정보는 수집·이용에 관한 동의일로부터
        &lt;3년&gt;까지 위 이용목적을 위하여 보유·이용됩니다.
      </p>
      <ul role="list">
        <li>보유근거 : 개인정보 동의</li>
        <li>관련법령 : 1) 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년</li>
        <li>2) 계약 또는 청약철회 등에 관한 기록 : 5년</li>
      </ul>

      <h3>4. 개인정보의 제3자 제공에 관한 사항</h3>
      <p>
        ① ‘회사’는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에
        해당하는 경우에만 개인정보를 제3자에게 제공합니다.
      </p>
      <p>② 그 외의 개인정보 3자 제공은 없습니다.</p>
      <h4>4-1. ‘회사’</h4>
      <ul role="list">
        <li>개인정보를 제공받는 자 : ‘회사’</li>
        <li>
          제공받는 자의 개인정보 이용목적 : 이메일, 휴대전화번호, 성별, 생년월일, 이름,
          회사전화번호, 직책, 부서, 회사명, 법정대리인 이름, 법정대리인 휴대전화번호
        </li>
        <li>제공받는 자의 보유·이용기간 : 3년</li>
      </ul>

      <h3>5. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</h3>
      <p>이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.</p>
      <p>
        ① 정보주체는 주식회사 ‘회사’에 대해 언제든지 개인정보 열람,정정,삭제,처리정지 요구
        등의 권리를 행사할 수 있습니다.
      </p>
      <p>
        ② 제1항에 따른 권리 행사는 주식회사 ‘회사’에 대해 개인정보 보호법 시행령 제41조제1항에
        따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 ‘회사’는 이에 대해 지체
        없이 조치하겠습니다.
      </p>
      <p>
        ③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을
        통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른
        위임장을 제출하셔야 합니다.
      </p>
      <p>
        ④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여
        정보주체의 권리가 제한 될 수 있습니다.
      </p>
      <p>
        ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어
        있는 경우에는 그 삭제를 요구할 수 없습니다.
      </p>
      <p>
        ⑥ ‘회사’는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람
        등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
      </p>

      <h3>6. 처리하는 개인정보의 항목 작성</h3>
      <p>① ‘회사’는 다음의 개인정보 항목을 처리하고 있습니다.</p>
      <h4>6-1. &lt;민원사무 처리&gt;</h4>
      <ul role="list">
        <li>
          필수항목 : 이메일, 휴대전화번호, 회사전화번호, 직책, 부서, 회사명, 법정대리인 이름,
          법정대리인 휴대전화번호
        </li>
        <li>선택항목 :</li>
      </ul>

      <h3>7. 개인정보의 파기</h3>
      <p>
        ‘회사’는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를
        파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
      </p>
      <h4>파기절차</h4>
      <p>
        이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부
        방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로
        옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
      </p>
      <h4>파기기한</h4>
      <p>
        이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일
        이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가
        불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일
        이내에 그 개인정보를 파기합니다.
      </p>
      <h4>파기방법</h4>
      <p>전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.</p>

      <h3>8. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h3>
      <p>
        ‘회사’는 정보주체의 이용정보를 저장하고 수시로 불러오는 ‘쿠키’를 사용하지 않습니다.
      </p>

      <h3>9. 개인정보 보호책임자 작성</h3>
      <p>
        ① ‘회사’는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한
        정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고
        있습니다.
      </p>
      <h4>▶ 개인정보보호책임자</h4>
      <ul role="list">
        <li>성명 : 이준형</li>
        <li>직책 : 센터장</li>
        <li>직급 : 책임연구원</li>
        <li>연락처 : 010-7410-0711</li>
      </ul>
      <p>
        ② 정보주체께서는 ‘회사’의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호
        관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로
        문의하실 수 있습니다. ‘회사’는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴
        것입니다.
      </p>

      <h3>10. 개인정보 처리방침 변경</h3>
      <p>
        ① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가,
        삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할
        것입니다.
      </p>

      <h3>11. 개인정보의 안전성 확보 조치</h3>
      <p>
        ‘회사’는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적
        및 물리적 조치를 하고 있습니다.
      </p>
      <h4>11-1. 개인정보 취급 직원의 최소화 및 교육</h4>
      <p>
        개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는
        대책을 시행하고 있습니다.
      </p>
      <h4>11-2. 해킹 등에 대비한 기술적 대책</h4>
      <p>
        ‘회사’는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여
        보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에
        시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
      </p>
      <h4>11-3. 개인정보의 암호화</h4>
      <p>
        이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며
        중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의
        별도 보안기능을 사용하고 있습니다.
      </p>
      <h4>11-4. 접속기록의 보관 및 위변조 방지</h4>
      <p>
        개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이
        위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.
      </p>
      <h4>11-5. 비인가자에 대한 출입 통제</h4>
      <p>
        개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립,
        운영하고 있습니다.
      </p>
    </div>
  );
}
